<template>
    <div v-if="ativado">
        <!-- Prescrições Ativas -->
        <div class="modal fade" id="prescricoesAtivasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Prescrições Ativas</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!lista || !lista.lista || !lista.lista.length" 
                            icon="fa-solid fa-pills"
                            msg="Nenhuma Prescrição Identificada" />

                        <div v-else>
                            <table class="table mb-0">
                                <thead>
                                    <tr>
                                        <th width="5%">
                                            Ativa
                                        </th>
                                        <th class="d-flex justify-content-between">
                                            <span>Prescrição</span>
                                            <div>
                                                <span class="badge badge-secondary ml-3">{{ ativas }} / {{ total }}</span>
                                            </div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(receita, irx) in lista.lista" :key="irx" :class="receita.ativa ? 'table-success' : 'table-danger'">
                                        <td width="5%">
                                            <input type="checkbox" v-model="receita.ativa" />

                                            <div class="small text-muted mt-3" title="ID da Prescrição">
                                                #{{ receita.id_receita }}
                                            </div>
                                        </td>
                                        <td>
                                            <order-set-view
                                                :view_only="true"
                                                :exibir_medico="true"
                                                :dados="[receita]"
                                                type="receita" />
                                            <!-- :atendimento="atendimento" -->
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="atualizar()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import OrderSetView from './OrderSetView.vue';

export default {
    data() {
        return { 
            lista: null,
            ativado: false, 
        };
    },

    components: { 
        OrderSetView,
        AzEmptyState,
        AzSubmit, 
    },

    computed: { 
        total: function() { 
            return ( this.lista && this.lista.lista ) ? this.lista.lista.length : 0;
        },

        ativas: function() { 
            return ( this.lista && this.lista.lista ) ? this.lista.lista.filter(item => item.ativa).length : 0;
        },
    },

    methods: { 
        atualizar () { 
            this.$util.load(this, { 
                service: 'enfermagem',
                func: 'atualizar_prescricoes_ativas',
                parms: { 
                    lista: this.lista.lista.map(item => { 
                        return { 
                            id_receita: item.id_receita,
                            ativa: item.ativa,
                        };
                    }),
                },
                loadTo: () => { 
                    $('#prescricoesAtivasModal').modal('hide');
                },
            });
        },

        abrir(id_paciente) { 
            this.ativado = true;
            this.lista = null; 

            this.$nextTick(() => { 
                $('#prescricoesAtivasModal').modal('show');
            });
            
            this.$util.load(this, { 
                service: 'prescricao',
                func: 'aprazamentos',
                parms: { 
                    paciente: { 
                        id_pessoa: id_paciente,
                    },
                    referencia: this.$util.hoje(),
                },
                loadTo: res => { 
                    this.lista = res;
                },
            });
        }
    }
}
</script>
